// Hebrew translations for M'art website
export const he = {
  // Navigation
  nav: {
    home: "בית",
    method: "השיטה",
    diy: "להכין לבד",
    product: "הדאודורנט המוכן",
    community: "קהילה",
    whyOpen: "הקוד הפתוח",
    downloadPdf: "הורדת מידע טכני"
  },

  // Home page
  home: {
    hero: {
      title: "דאודורנט טבעי. הידע חופשי.",
      subtitle: "דאודורנט טבעי לייצור עצמי בעזרת נוסחא פתוחה, בחינם, לכל מי שרוצה להכין לבד או שאפשר לרכוש מוכן לשימוש. מרכיבים טהורים, שקיפות מלאה.",
      fullGuide: "מדריך מלא",
      notCorporate: "מותג עצמאי",
      freeKnowledge: "ידע פתוח"
    },
    paths: {
      title: "איך תרצו להתחיל?",
      diy: {
        title: "להכין לבד",
        subtitle: "חינם",
        description: "גישה מלאה לפורמולה, רשימת מרכיבים והוראות ייצור"
      },
      buy: {
        title: "לקנות מוכן",
        subtitle: "50 ₪",
        description: "בדיוק אותו מוצר, רק מוכן עבורך. 50 מ״ל."
      },
      community: {
        title: "לראות ניסויים",
        subtitle: "קהילה",
        description: "ניסויים של אנשים אחרים, טיפים ושיתופי ידע"
      }
    }
  },

  // Method page
  method: {
    title: "השיטה",
    subtitle: "הפילוסופיה והלוגיקה מאחורי הפורמולה",
    sections: {
      whyNatural: {
        title: "למה דאודורנט טבעי?",
        content: "הדאודורנטים המסחריים מכילים אלומיניום, פרבנים וכימיקלים שנספגים בעור. הגוף יודע לווסת את עצמו, כל מה שצריך זה לעזור לו, לא להילחם בו."
      },
      whyFormulation: {
        title: "למה הפורמולה הזו עובדת?",
        content: "השילוב של סודיום ביקרבונט (סודה לשתייה באיכות קוסמטית) לנטרול pH, עמילן תירס לספיגת לחות ושמנים טבעיים אנטי-בקטריאליים יוצר מענה מלא לריח גוף, בלי לחסום נקבוביות."
      },
      whyOpen: {
        title: "למה פתיחות חשובה?",
        content: "כשיודעים מה בפנים, אפשר לבחור. אפשר להתאים. אפשר לשפר. שקיפות מחזקת קהילות ומאפשרת בחירה אמיתית."
      },
      whyAI: {
        title: "למה AI שימש ככלי?",
        content: "AI עזר לנתח מאות נוסחאות, לזהות יחסים מיטביים בין מרכיבים ולהתאים את הפורמולה לתנאי אקלים שונים. הכלי הוא שלנו, התוצאה היא שלכם."
      }
    }
  },

  // DIY page - Full formulation
  diy: {
    title: "להכין לבד",
    subtitle: "גישה מלאה לפורמולה, בחינם, ללא הרשמה",
    
    overview: {
      title: "מה בפנים?",
      description: "הפורמולה מבוססת על ארבע אבני יסוד: בסיס שומנים, אבקות פעילות, מייצבים ומרגיעים, וניחוח טבעי."
    },

    ingredients: {
      title: "רשימת מרכיבים (100 גרם)",
      items: [
        {
          key: "coconutOil",
          name: "שמן קוקוס",
          role: "בסיס שומני עיקרי ונשא לשאר המרכיבים",
          action: "אנטיבקטריאלי טבעי, מסייע בניטרול חיידקים גורמי ריח",
          texture: "נמס במגע עם העור, יוצר תחושה קרמית וחלקה",
          amount: "2.5 כפות / 7.5 כפיות",
          volume: "37.5 גרם",
          percent: "37.5%"
        },
        {
          key: "sheaButter",
          name: "חמאת שיאה",
          role: "מרכך ומייצב",
          action: "עשירה בוויטמינים A ו-E, מרגיעה עור מגורה",
          texture: "מוסיפה גוף וסמיכות קרמית",
          amount: "1.3 כפות / 4 כפיות",
          volume: "20 גרם",
          percent: "20%"
        },
        {
          key: "cornStarch",
          name: "עמילן תירס",
          role: "סופח לחות וריח",
          action: "סופג זיעה קלה ומשאיר תחושת עור יבש",
          texture: "מעניק מראה קטיפתי, חלק ולא מבריק",
          amount: "1.1 כפות / 3.5 כפיות",
          volume: "17.5 גרם",
          percent: "17.5%"
        },
        {
          key: "bakingSoda",
          name: "סודיום ביקרבונט",
          quality: "סודה לשתייה באיכות קוסמטית",
          role: "החומר הפעיל לניטרול ריח",
          action: "מאזן pH ומונע התרבות חיידקים",
          amount: "1 כף / 3 כפיות",
          volume: "15 גרם",
          percent: "15%"
        },
        {
          key: "beeswax",
          name: "שעוות דבורים",
          role: "מייצב טבעי",
          action: "שומרת על יציבות התערובת ומונעת הפרדה",
          texture: "מרקם רך יותר, מפחית קשיחות ומקל על המריחה",
          amount: "0.3 כפות / 1 כפית",
          volume: "5 גרם",
          percent: "5%"
        },
        {
          key: "aloeVera",
          name: "ג׳ל אלוורה",
          role: "ריכוך, קירור והוספת לחות",
          action: "מרגיע עור ומאזן את פעולת הסודיום ביקרבונט",
          texture: "תורם לתחושת רעננות",
          amount: "0.3 כפות / 0.9 כפית",
          volume: "4.5 גרם",
          percent: "4.5%"
        },
        {
          key: "essentialOil",
          name: "שמנים אתריים (לבנדר או לבחירה)",
          role: "ניחוח וחיטוי טבעי",
          action: "אנטיבקטריאלי ומרענן",
          amount: "כ-10 טיפות",
          volume: "0.5 גרם",
          percent: "0.5%"
        }
      ]
    },

    proportions: {
      title: "יחס פורמולציה (אחוזים, לפי 100 גרם)",
      items: [
        { key: "coconutOil", name: "שמן קוקוס" },
        { key: "sheaButter", name: "חמאת שיאה" },
        { key: "cornStarch", name: "עמילן תירס" },
        { key: "bakingSoda", name: "סודה לשתייה (קוסמטית)" },
        { key: "beeswax", name: "שעוות דבורים" },
        { key: "aloeVera", name: "ג׳ל אלוורה" },
        { key: "essentialOil", name: "שמנים אתריים" }
      ],
      note: "סה״כ 100%, האחוזים עשויים להשתנות מעט בהתאם לצמיגות שמן הקוקוס"
    },

    stabilizationTip: {
      title: "טיפ לייצוב הפורמולה (מניעת היפרדות)",
      content: "ג׳ל אלוורה מכיל פאזה מימית שאינה מתערבבת באופן טבעי עם שמנים וחמאות, מה שעלול להוביל להיפרדות המוצר או להיווצרות עובש ללא חומר משמר מתאים.",
      alternative: "מעדיפים להכין דאודורנט ללא סיכון להיפרדות? ניתן לוותר לחלוטין על ג׳ל האלוורה ולהוסיף את המשקל הזה ישירות לחמאת השיאה. שינוי זה יעניק למוצר יציבות מלאה לאורך זמן, מרקם עשיר וחלק, ויבטל את הצורך בחומר משמר.",
      castorOil: "לחלופין, ניתן להשתמש בשמן קיק (Castor Oil) כתחליף לג׳ל אלוורה, שמן קיק מתערבב היטב עם שמנים ושומנים ומספק ייצוב טבעי ללא סיכון להיפרדות."
    },

    seoDescription: "הפורמולה שלנו מבוססת בעיקרה על שמן קוקוס וחמאת שיאה כבסיס שומני טבעי, בשילוב עמילן תירס וסודה לשתייה באיכות קוסמטית לנטרול ריחות. שעוות דבורים מייצבת את המרקם, ג׳ל אלוורה מרגיע את העור, ושמנים אתריים מוסיפים ניחוח טבעי. כל המרכיבים טבעיים לחלוטין, ללא אלומיניום, ללא פרבנים, וללא כימיקלים מזיקים.",

    process: {
      title: "סדר העמסה טכני, תהליך ייצור",
      steps: [
        {
          number: 1,
          title: "שלב המסה (בן מארי)",
          content: "בקערת זכוכית חסינת חום, ממיסים יחד שמן קוקוס, חמאת שיאה ושעוות דבורים. מחממים בבן מארי עד המסה מלאה ואחידה.",
          warning: "טמפרטורה מומלצת: עד 40°C, לא יותר, כדי לשמור על איכות המרכיבים."
        },
        {
          number: 2,
          title: "שלב קירור",
          content: "להסיר מהאש ולהמתין 1-2 דקות. להוסיף ג׳ל אלוורה ולערבב היטב עד קבלת תערובת חלקה."
        },
        {
          number: 3,
          title: "שלב האבקות",
          content: "בקערה נפרדת לערבב היטב את הסודה לשתייה ועמילן התירס. להוסיף בהדרגה לתערובת החמה תוך ערבוב רציף עד אחידות מלאה וללא גושים."
        },
        {
          number: 4,
          title: "שלב סופי, שמנים אתריים",
          content: "כאשר התערובת חמימה אך לא חמה: להוסיף שמנים אתריים ולערבב היטב לפיזור אחיד."
        },
        {
          number: 5,
          title: "יציקה והתמצקות",
          content: "להעביר לצנצנת זכוכית נקייה. להניח להתמצקות בטמפרטורת החדר למשך 3-4 שעות."
        }
      ]
    },

    usage: {
      title: "הוראות שימוש",
      instructions: [
        "קחו כמות קטנה מהדאודורנט בעזרת כפית נקייה",
        "מרחו שכבה דקה על עור נקי ויבש בבית השחי",
        "אפשרו לדאודורנט מספר שניות להיספג לפני לבישת הבגד"
      ],
      frequency: "תדירות: 1-2 פעמים ביום, לפי הצורך",
      cleaning: "ניקוי הכפית: לאחר כל שימוש יש לנקות את הכפית בנייר נקי ויבש",
      storage: "אחסון: יש לאחסן במקום קריר ויבש, הרחק מחום ישיר"
    },

    tips: {
      title: "טיפ",
      content: "במידה והחומר מתקשה עקב מזג אוויר קר או משתנה במרקם, ניתן להוסיף מעט ג׳ל אלוורה או שמן קוקוס, לערבב היטב ולהחזיר למרקם הרצוי."
    },

    sensitivity: {
      title: "הערות רגישות",
      content: "זהו ניסיון משותף, לא ייעוץ רפואי. כל משתמש אחראי לעורו שלו. אין התחייבויות, אין הבטחות, רק שקיפות מלאה."
    }
  },

  // Product page
  product: {
    title: "הדאודורנט המוכן",
    subtitle: "בדיוק אותו תהליך, רק מוכן עבורך",
    description: "אם אין לך זמן או חשק להכין לבד, אפשר פשוט לקנות. זה בדיוק אותו מוצר, אותם מרכיבים, אותו תהליך.",
    price: "50 ₪",
    volume: "50 מ״ל",
    includes: [
      "צנצנת זכוכית ענברית",
      "כפית עץ",
      "הוראות שימוש"
    ],
    cta: "לרכישה בוואטסאפ",
    note: "הרכישה היא אופציונלית. כל המידע זמין בחינם בעמוד ״להכין לבד״.",
    whatsappMessage: "היי M'art, אשמח להזמין דאודורנט טבעי (50 מ״ל, 50 ₪)"
  },

  // Community page
  community: {
    title: "קהילה",
    subtitle: "מעבדה משותפת, לא רשת חברתית",
    description: "כאן אפשר לשתף ניסויים, תוצאות ותובנות. זה לא מקום לפרסום או שיווק, זה מחברת מעבדה משותפת.",
    loginPrompt: "התחברו עם Google כדי לשתף",
    loginButton: "התחברות עם Google",
    logoutButton: "התנתקות",
    newPost: {
      placeholder: "שתפו את הניסוי שלכם...",
      addImages: "הוסיפו תמונות (עד 3)",
      submit: "פרסום"
    },
    comments: {
      title: "תגובות",
      placeholder: "כתבו תגובה...",
      submit: "שליחה"
    },
    empty: "עדיין אין פרסומים. היו הראשונים לשתף!"
  },

  // Why Open page
  whyOpen: {
    title: "למה זה פתוח?",
    subtitle: "מניפסט לקוסמטיקה שקופה",
    sections: {
      corporations: {
        title: "הסיבה לעשות בעצמך",
        content: "מותגי קוסמטיקה גדולים משקיעים הרבה במותג, אריזה ופרסום, ופחות במוצר עצמו. אנחנו מאמינים שאפשר אחרת: מרכיבים איכותיים, מחיר הוגן, ושקיפות מלאה."
      },
      free: {
        title: "למה הפורמולה חינם?",
        content: "כי ידע צריך להיות נגיש. אם מישהו רוצה להכין לבד, שיכין. אם מישהו מעדיף לקנות מוכן, יש אפשרות גם לזה. אין מניפולציה, אין הסתרה."
      },
      feedback: {
        title: "למה משוב חשוב?",
        content: "אנחנו לא מושלמים. אם יש לכם רעיון לשיפור, שינוי, התאמה, נשמח לשמוע. הפורמולה הזו היא נקודת התחלה, לא נקודת סיום."
      },
      testing: {
        title: "האם רעיונות נבדקים?",
        content: "תגובות טובות וניסויים מעניינים עשויים להיבחן בפועל לאחר התייעצות עם AI, בשקיפות מלאה. אם משהו עובד טוב יותר, נאמץ אותו."
      }
    },
    statement: "האתר הזה נבנה כדי שתוכלו לדעת, לבחור וליצור בעצמכם את המוצרים היום-יומיים שלכם."
  },

  // Footer
  footer: {
    disclaimer: "זהו ניסיון משותף, לא ייעוץ רפואי. כל משתמש אחראי לעורו שלו.",
    copyright: "© M'art, דאודורנט טבעי בקוד פתוח"
  },

  // Common
  common: {
    loading: "טוען...",
    error: "שגיאה",
    back: "חזרה",
    close: "סגור"
  }
};

export default he;
